import Vue from '@/setup'

import EntryWidget from '@/modules/EntryWidget/components/EntryWidget'
import store from '@/store'

import '@/modules/EntryWidget/assets/style/grid.css'
import '@/modules/EntryWidget/assets/style/overwrites.css'

const widgets = document.querySelectorAll('.sanitasOvpEntry')
let notificationsEnabled = true

widgets.forEach(element => {
  const props = element.dataset
  if (notificationsEnabled) {
    props.notificationsEnabled = ''
  }
  notificationsEnabled = false

  // Transform props string-booleans to boolean (for TRUE we need an empty string)
  if (props.header === 'true' || props.header === '') {
    props.header = ''
  } else {
    delete props.header
  }
  if (props.tiny === 'true' || props.tiny === '') {
    props.tiny = ''
  } else {
    delete props.tiny
  }

  // Fallback for old AEM implementation
  if (props.whiteBackground === 'true' || props.whiteBackground === '') {
    props.theme = 'light'
  }

  return new EntryWidget({
    el: element,
    propsData: { ...props },
    store,
    i18n: Vue.prototype.i18n,
  })
})
